import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=328bd8a7&scoped=true"
import script from "./Generator.vue?vue&type=script&lang=ts"
export * from "./Generator.vue?vue&type=script&lang=ts"
import style0 from "./Generator.vue?vue&type=style&index=0&id=328bd8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328bd8a7",
  null
  
)

export default component.exports